
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Footer extends Vue {
  public name: string = "Footer";
  protected currentYear: Number = new Date().getFullYear();
}
